module.exports = __webpack_public_path__ + "img/excel_icon.64022380.png";